// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"718":"design-project","810":"production-order"}[chunkId] + "." + {"718":"d5f7fd97","810":"77046e82"}[chunkId] + ".css";
};